module.exports = __webpack_public_path__ + "static/media/instacart.851dc325.png";